import type { GuideConfig } from './types';

export const jewelryGuide: GuideConfig = {
  categoryKey: 'jewelry',
  title: '신부님의 예물 기준을 정리해드릴게요',
  subtitle: '현직 플래너의 질문을 바탕으로\n나에게 맞는 예물 선택 기준을 확인해보세요.',
  plannerIntro: '플래너 기준 기반',
  questionCount: 5,
  estimatedTime: '약 60초',

  questions: [
    {
      id: 'j1',
      category: '예산',
      questionText: '예물 예산은 어느 정도로 생각하고 계신가요?',
      helperText: '커플링, 시계, 다이아몬드 등을 포함한 총 예산 기준으로 선택해주세요.',
      selectionType: 'single',
      options: [
        { id: 'j1-under-1m', label: '100만원 미만', description: '심플한 커플링 위주', resultType: 'practical', reaction: '합리적인 예산으로도 의미 있는 예물을 준비할 수 있어요. 커플링에 집중하는 것도 좋은 선택이에요.' },
        { id: 'j1-1m-3m', label: '100~300만원', description: '커플링 + 알찬 구성', resultType: 'classic', reaction: '클래식한 예물 구성이 가능한 예산이에요. 커플링과 작은 다이아를 함께 보시면 좋아요.' },
        { id: 'j1-3m-5m', label: '300~500만원', description: '커플링 + 시계 고려', resultType: 'modern', reaction: '트렌디한 브랜드 시계나 1캐럿 다이아까지 고려할 수 있는 예산이에요. 선택의 폭이 꽤 넓어요.' },
        { id: 'j1-over-5m', label: '500만원 이상', description: '프리미엄 풀 패키지', resultType: 'luxury', reaction: '명품 브랜드나 GIA 인증 하이퀄리티 다이아까지 가능한 예산이에요. 평생 간직할 예물을 고르실 수 있어요.' },
      ],
      tipText: '예물 예산은 커플링, 시계, 목걸이·귀걸이 등 전체 구성을 기준으로 잡는 게 좋아요. 브랜드보다 등급과 디자인을 먼저 보는 걸 추천드려요.',
    },
    {
      id: 'j2',
      category: '디자인',
      questionText: '예물 디자인에서 가장 중요하게 생각하는 것은 무엇인가요?',
      helperText: '평소 즐겨 착용하는 주얼리 스타일을 떠올려보세요.',
      selectionType: 'single',
      options: [
        { id: 'j2-classic', label: '클래식하고 변하지 않는', description: '10년 후에도 질리지 않을 디자인', resultType: 'classic', reaction: '클래식 디자인은 유행을 타지 않아서 오래 착용하기 좋아요. 결혼 예물로 가장 무난한 선택이에요.' },
        { id: 'j2-trendy', label: '트렌디한 감각', description: '요즘 인기 있는 스타일과 브랜드', resultType: 'modern', reaction: '트렌드를 아는 감각적인 선택이에요. 요즘은 미니멀하면서도 포인트 있는 디자인이 인기예요.' },
        { id: 'j2-practical', label: '데일리로 매일 착용', description: '실용적이고 편안한 디자인', resultType: 'practical', reaction: '매일 착용할 수 있는 실용적인 디자인이라면 예물의 가치가 배가 돼요. 심플하면서도 튼튼한 스타일이 좋아요.' },
        { id: 'j2-luxury', label: '명품 브랜드의 품격', description: '브랜드 가치와 희소성 중시', resultType: 'luxury', reaction: '명품 브랜드 예물은 시간이 지나도 가치가 유지되고 특별함이 남아요. 티파니, 까르띠에, 불가리 등이 대표적이에요.' },
      ],
      tipText: '예물은 평생 함께하는 주얼리예요. 유행을 따르기보다는 본인의 평소 스타일과 잘 어울리는 디자인을 고르는 게 가장 중요해요.',
    },
    {
      id: 'j3',
      category: '다이아몬드',
      questionText: '다이아몬드의 등급과 스펙을 어느 정도로 생각하시나요?',
      helperText: '4C(중량, 컬러, 투명도, 컷) 중 어디에 비중을 둘지 기준으로 선택해주세요.',
      selectionType: 'single',
      options: [
        { id: 'j3-practical', label: '실용적인 등급이면 충분', description: '육안으로 깨끗하면 OK', resultType: 'practical', reaction: '실용적인 등급의 다이아도 육안으로는 상급과 큰 차이가 없어요. 가성비 좋은 선택이에요.' },
        { id: 'j3-classic', label: '기본 4C 수준', description: 'G컬러·VS 등급 이상', resultType: 'classic', reaction: '기본 4C 수준이면 대부분의 주얼리에서 충분히 아름다운 광채를 보여줘요. 무난한 클래식 선택이에요.' },
        { id: 'j3-modern', label: '감정서 기준 상위 등급', description: '트리플 엑설런트 컷 선호', resultType: 'modern', reaction: '상위 등급 다이아는 빛 반사가 확실히 달라요. 특히 컷 등급이 높으면 작은 다이아도 눈에 띄게 빛나요.' },
        { id: 'j3-luxury', label: '최상급 GIA 인증 + 1캐럿 이상', description: '투자 가치도 함께 고려', resultType: 'luxury', reaction: '최상급 GIA 인증 다이아는 희소성과 투자 가치까지 있어요. 평생 간직할 만한 가치 있는 선택이에요.' },
      ],
      tipText: '다이아몬드는 컷(Cut) 등급이 가장 중요해요. 컷이 좋으면 작은 다이아도 훨씬 빛나 보여요. 컬러와 투명도는 육안으로 구분하기 어려운 경우가 많아요.',
    },
    {
      id: 'j4',
      category: '커플링',
      questionText: '커플링은 어떤 스타일을 선호하시나요?',
      helperText: '두 분이 매일 착용할 반지인 만큼 착용감과 디자인을 함께 고려해주세요.',
      selectionType: 'single',
      options: [
        { id: 'j4-simple', label: '심플하고 얇은 밴드', description: '매일 착용하기 편한 무난한 디자인', resultType: 'practical', reaction: '심플한 커플링은 어디에나 잘 어울리고 오래 착용해도 질리지 않아요. 실용적인 선택이에요.' },
        { id: 'j4-classic', label: '클래식 라운드', description: '기본에 충실한 정석 디자인', resultType: 'classic', reaction: '클래식 라운드 커플링은 유행을 타지 않는 정석이에요. 남녀 모두 부담 없이 착용할 수 있어요.' },
        { id: 'j4-unique', label: '개성 있는 디자인', description: '트위스트, 각인, 믹스 메탈 등', resultType: 'modern', reaction: '두 분만의 개성을 담은 커플링은 특별한 의미가 있어요. 맞춤 각인이나 독특한 디자인으로 유니크함을 살려보세요.' },
        { id: 'j4-luxury', label: '명품 브랜드 커플링', description: '까르띠에, 티파니, 불가리 등', resultType: 'luxury', reaction: '명품 브랜드 커플링은 그 자체로 특별함과 품격을 선사해요. 평생 소장할 가치가 있는 예물이에요.' },
      ],
      tipText: '커플링은 매일 착용하는 반지인 만큼, 디자인보다 착용감과 내구성이 더 중요해요. 꼭 직접 껴보고 결정하는 걸 추천드려요.',
    },
    {
      id: 'j5',
      category: '구성 선호',
      questionText: '추가로 관심 있는 예물 구성이 있나요?',
      helperText: '여러 개 선택할 수 있어요. 커플링 외에 함께 준비하고 싶은 구성을 골라주세요.',
      selectionType: 'multi',
      options: [
        { id: 'j5-ring-only', label: '커플링에만 집중', description: '반지 하나에 의미를 담고 싶어요', resultType: 'practical', reaction: '커플링 하나에 모든 의미를 담는 것도 충분히 아름다운 선택이에요. 심플함이 오히려 더 특별할 수 있어요.' },
        { id: 'j5-diamond', label: '다이아몬드 목걸이/귀걸이', description: '다이아 주얼리도 함께', resultType: 'classic', reaction: '다이아몬드 주얼리는 결혼식 당일에도 빛나고 평생 소장할 수 있어요. 클래식한 구성이에요.' },
        { id: 'j5-watch', label: '예물 시계', description: '커플 시계도 고려 중이에요', resultType: 'modern', reaction: '예물 시계는 실용성과 품격을 모두 갖춘 선택이에요. 매일 착용하며 두 사람의 시간을 함께 새길 수 있어요.' },
        { id: 'j5-full-set', label: '풀 주얼리 세트', description: '목걸이·귀걸이·팔찌까지', resultType: 'luxury', reaction: '풀 주얼리 세트는 예물의 정석이에요. 세트로 맞추면 디자인 통일감도 있고 협상 여지도 생겨요.' },
      ],
      tipText: '예물 구성은 커플링을 기본으로 하고, 예산에 따라 시계나 다이아 주얼리를 추가하는 방식이 가장 일반적이에요. 한 번에 모두 맞추기보다 우선순위를 정해서 진행하는 걸 추천드려요.',
    },
  ],

  results: [
    {
      key: 'practical',
      displayName: '실속 실용형',
      summary: '의미와 실용성을 모두 잡는 타입이에요. 커플링에 집중하고 합리적인 예산으로 알찬 예물 구성을 원하는 분께 적합해요.',
      plannerInterpretation: '예물은 가격보다 의미가 중요해요. 실용적인 등급의 다이아도 육안으로 충분히 아름답고, 매일 착용할 수 있는 심플한 디자인이 오히려 더 가치 있을 수 있어요. 커플링에 집중하는 전략이 가장 현명한 선택이에요.',
      recommendDirection: '심플한 디자인의 커플링을 메인으로 하고, 작은 다이아 목걸이를 포인트로 추가하는 구성을 추천드려요. 브랜드보다는 실물 디자인과 착용감을 기준으로 비교해보세요.',
      keywords: ['실속 있는', '데일리', '의미 중심'],
      styleProfile: [
        { label: '디자인 심플도', value: 90 },
        { label: '브랜드 선호도', value: 20 },
        { label: '다이아 관심도', value: 30 },
        { label: '실용성 중시', value: 90 },
        { label: '클래식 선호', value: 40 },
      ],
      recommendedCombo: '심플 커플링 + 미니 다이아 목걸이',
      situationalGuides: [
        {
          title: '예산을 효율적으로 쓰고 싶을 때',
          description: '커플링에 예산의 70%를 투자하고, 남은 금액으로 작은 다이아 목걸이를 추가하면 알찬 구성이 완성돼요.',
        },
        {
          title: '매일 착용할 수 있는 예물을 원할 때',
          description: '얇고 심플한 밴드 커플링은 일상에서도 부담 없이 착용할 수 있어요. 내구성이 좋은 플래티넘이나 18K를 추천드려요.',
        },
        {
          title: '브랜드보다 디자인이 중요할 때',
          description: '브랜드가 없는 주얼리숍도 디자인과 퀄리티가 훌륭한 곳이 많아요. 직접 보고 착용해보고 결정하는 게 가장 정확해요.',
        },
      ],
    },
    {
      key: 'classic',
      displayName: '클래식 밸런스형',
      summary: '안정적이면서도 품격 있는 예물을 원하는 타입이에요. 클래식한 디자인과 적절한 등급의 다이아로 균형 잡힌 구성을 추천드려요.',
      plannerInterpretation: '클래식은 유행을 타지 않아요. 적절한 등급의 다이아와 무난한 디자인으로 10년, 20년 후에도 손색없는 예물을 만들 수 있어요. 커플링 + 다이아 목걸이 구성이 가장 안정적인 선택이에요.',
      recommendDirection: '기본 4C 등급의 3~5부 다이아 목걸이와 클래식 라운드 커플링을 메인으로 추천드려요. 브랜드보다는 신뢰할 수 있는 주얼리숍의 애프터서비스를 확인하는 게 중요해요.',
      keywords: ['균형 잡힌', '클래식', '기본에 충실'],
      styleProfile: [
        { label: '디자인 심플도', value: 60 },
        { label: '브랜드 선호도', value: 50 },
        { label: '다이아 관심도', value: 60 },
        { label: '실용성 중시', value: 60 },
        { label: '클래식 선호', value: 85 },
      ],
      recommendedCombo: '클래식 커플링 + 3~5부 다이아 목걸이',
      situationalGuides: [
        {
          title: '무난하면서도 격식 있는 예물을 원할 때',
          description: '클래식 라운드 커플링과 기본 4C 수준의 다이아 조합은 실패할 확률이 가장 낮은 구성이에요. 누구에게나 잘 어울려요.',
        },
        {
          title: '양가 부모님도 함께 보실 때',
          description: '너무 트렌디한 디자인보다는 클래식한 디자인이 양가 부모님께도 좋은 인상을 드려요. 전통적인 아름다움이 있는 구성이에요.',
        },
        {
          title: '첫 주얼리 구매라 막막할 때',
          description: '클래식 구성은 주얼리에 대해 잘 몰라도 실패할 확률이 낮아요. 믿을 수 있는 인증업체에서 기본 구성을 추천받아보세요.',
        },
      ],
    },
    {
      key: 'modern',
      displayName: '트렌디 감각형',
      summary: '디자인 감각과 브랜드 가치를 중요하게 생각하는 타입이에요. 트렌디한 스타일과 상위 등급의 다이아, 그리고 예물 시계까지 고려한 감각적인 구성을 추천드려요.',
      plannerInterpretation: '트렌드를 아는 분들은 예물에서도 남다른 감각을 원하시죠. 트리플 엑설런트 컷 다이아나 감각적인 디자인의 커플링은 착용하는 순간의 만족감이 남다릅니다. 시계까지 함께 고려하면 더 완성도 높은 예물 구성이 가능해요.',
      recommendDirection: '감각적인 디자인의 커플링 + 트리플 엑설런트 다이아 + 예물 시계 조합을 추천드려요. 믹스 메탈이나 독특한 각인이 들어간 커플링도 고려해보세요.',
      keywords: ['트렌디', '감각적', '브랜드'],
      styleProfile: [
        { label: '디자인 심플도', value: 35 },
        { label: '브랜드 선호도', value: 75 },
        { label: '다이아 관심도', value: 80 },
        { label: '실용성 중시', value: 50 },
        { label: '클래식 선호', value: 30 },
      ],
      recommendedCombo: '감각적 커플링 + 상위 등급 다이아 + 예물 시계',
      situationalGuides: [
        {
          title: '남들과 다른 예물을 원할 때',
          description: '트위스트 밴드, 믹스 메탈, 맞춤 각인 등 개성 있는 디자인으로 두 분만의 특별한 커플링을 만들 수 있어요.',
        },
        {
          title: '시계도 함께 예물로 준비하고 싶을 때',
          description: '커플 시계는 시간을 함께한다는 의미도 있고 실용성도 높아요. 예물 시계는 클래식한 디자인이 오래 가치를 유지해요.',
        },
        {
          title: '다이아 스펙에 신경 쓰고 싶을 때',
          description: '트리플 엑설런트 컷 등급의 다이아는 작은 크기에서도 압도적인 광채를 보여줘요. GIA 감정서가 있는 다이아를 선택하세요.',
        },
      ],
    },
    {
      key: 'luxury',
      displayName: '프리미엄 컬렉터형',
      summary: '예물을 평생의 자산으로 생각하는 타입이에요. 명품 브랜드, 최상급 GIA 다이아, 풀 주얼리 세트로 완성하는 프리미엄 예물 구성을 추천드려요.',
      plannerInterpretation: '프리미엄 예물은 단순한 액세서리가 아니라 투자이자 유산이에요. 티파니, 까르띠에, 불가리 같은 명품 브랜드는 시간이 지날수록 가치가 유지되고, 최상급 다이아는 희소성으로 인해 오히려 가격이 오르기도 해요.',
      recommendDirection: '명품 브랜드 커플링 + 1캐럿 이상 GIA 인증 다이아 + 풀 주얼리 세트 구성을 추천드려요. 브랜드 부티크에서 직접 상담받고 구매하는 걸 권장해요.',
      keywords: ['명품', '투자 가치', '최상급'],
      styleProfile: [
        { label: '디자인 심플도', value: 20 },
        { label: '브랜드 선호도', value: 95 },
        { label: '다이아 관심도', value: 95 },
        { label: '실용성 중시', value: 25 },
        { label: '클래식 선호', value: 70 },
      ],
      recommendedCombo: '명품 커플링 + 1캐럿 GIA 다이아 + 주얼리 세트',
      situationalGuides: [
        {
          title: '평생 소장할 가치 있는 예물을 원할 때',
          description: '명품 브랜드의 아이코닉 라인은 유행을 타지 않고 오히려 시간이 지날수록 가치가 올라가요. 까르띠에 러브링, 티파니 T 라인 등이 대표적이에요.',
        },
        {
          title: '투자 관점에서 예물을 생각할 때',
          description: '1캐럿 이상 GIA 인증 다이아는 희소성과 투자 가치를 동시에 갖춰요. 특히 컷 등급이 엑설런트면 감정서 가치가 더 올라가요.',
        },
        {
          title: '최고의 퀄리티로 준비하고 싶을 때',
          description: '브랜드 부티크에서 예물 전담 컨설턴트와 1:1 상담을 통해 진행하면 훨씬 만족도가 높아요. 미리 예약하고 방문하는 걸 추천드려요.',
        },
      ],
    },
  ],

  calculateResult(answers: Record<string, string[]>): string {
    const scores: Record<string, number> = {
      practical: 0,
      classic: 0,
      modern: 0,
      luxury: 0,
    };

    Object.entries(answers).forEach(([questionId, selectedIds]) => {
      const question = jewelryGuide.questions.find((q) => q.id === questionId);
      if (!question) return;

      selectedIds.forEach((optionId) => {
        const option = question.options.find((o) => o.id === optionId);
        if (!option || !option.resultType) return;

        if (scores[option.resultType] !== undefined) {
          scores[option.resultType] += 1;
        }
      });
    });

    let maxType = 'classic';
    let maxScore = 0;
    Object.entries(scores).forEach(([type, score]) => {
      if (score > maxScore) {
        maxScore = score;
        maxType = type;
      }
    });

    return maxType;
  },
  enabled: true,
  headerTitle: '예물 가이드',
  startTitle: '두 사람의 약속을\n담는 반짝임',
  startDescription: '현직 웨딩 플래너 12인이 검증한\n예물 의사결정 기준',
  startCtaText: '예물 기준 찾기',
  hubMainCopy: '두 사람의 약속을 담는 반짝임',
  hubDescription: '예산, 디자인, 다이아 기준을 정리해\n우리에게 맞는 예물 선택 방향을 확인해보세요.',
  hubTags: ['다이아몬드', '커플링', '시계', '골드'],
};